export const checkout = {
  upload: {
    choose3DFile: "Choisir le fichier 3D",
    startDemo: "Commencer la demo",
    dontHaveAFileYet: "Pas de fichier 3D?",
    dragAndDrop3DFile:
      "Chargez votre fichier 3D en utilisant la fonction glisser-déposer",
    or: "ou",
    defaultHeader: "Portail en ligne de commande",
    defaultSubtitle: "Chargez vos fichiers ici",
    chooseDifferent3DFile: "Charger un nouveau objet",
    addAnother3DFile: "Charger un autre fichier 3D",
    uploadState: {
      convertingToSTL: "Conversion en stl en cours",
      analyzing: "Analyse en cours",
      convertingToTRF: "Conversion en rtf en cours",
      analyzingDimensions: "Analyse de volume et dimensions en cours",
      fileIsUploading: "Téléchargement en cours",
      repairing: "Réparation du fichier en cours",
    },
  },
  analysis: {
    printQualityInfo: {
      tooLargeHeader: "L'objet est trop large pour tous les modes d'impression",
      mightCauseProblemsHeader:
        "Les résultats d'impression peuvent être améliorer",
      mightCauseProblemsBody:
        "Certaines parties du modèle peuvent être trop fines en raison de la mise à l'échelle actuelle. Visitez <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>design guidelines</a> pour plus d'informations.",
      filePrintableHeader: "Impression 3D est possible:",
      filePrintableBody:
        "Aucun problème n'est survenu lors du contrôle automatique du modèle. Veuillez consulter notre <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>design guidelines</a> pour plus d'informations.",
      tooLargeForSelectedPrintmodeHeader:
        "L'objet est trop grand pour le mode d'impression choisi.",
      printabilityIsBeingCalculated: "Vérification de l'imprimabilité en cours",
    },
  },
  configure: {
    objectMeasurements: "Votre objet a les dimensions suivantes",
    "3dRendement": "3D-Vue",
    wallThicknesses: "Épaisseur du mur",
    repairData: "Info sur la réparation",
    inputLabels: {
      objectName: "Nom de l'objet",
      givenUnitOfLength: "Quelle unité de longueur a été utilisée ?",
      materialAndColor: "Veuillez sélectionner le matériau et les couleurs :",
      scale: "Échelle",
      unit: "Unité",
      quantity: "Quantité",
      finishOptions: "Finition de la surface",
    },
    rotateObjectInstruction:
      "Faites pivoter l'objet en le faisant glisser avec votre souris.",
  },
  nextStep: "Suivant",
  addToCart: "Ajouter au panier d'achat",
  steps: {
    choose3DFile: "Charger le fichier 3D",
    choosePrintMode: "Sélectionner les paramètres d'impression",
    checkout: "Vers la caisse",
  },
  cart: {
    label: "Panier",
    cartIsEmpty: "Votre panier est vide.",
    editCart: "Modifier le contenu du panier",
    actionLabels: {
      chooseFinishes: "Poursuivre",
      goBack: "Retour",
      close: "Fermer",
      addToCart: "Ajouter au panier",
      generateQuote: "Obtenir une offre",
      completeOrder: "Commander maintenant",
      editPaymentDetails: "Modifier les détails du paiement",
    },
    noTaxIncluded: "Taxes non incluses",
    includingVAT:
      "Tous les prix incluent la taxe sur la valeur ajoutée (si applicable).",
    includingXPercentTaxes:
      "Tous les prix incluent {taxRate} % de TVA. (si applicable)",
    plusXPercentTaxes: "plus {taxRate} % de TVA",
    isPiecePrice: "Prix par pièce",
    isFullPrice: "Somme totale",
    itemLabels: {
      name: "Article",
      size: "Taille en ",
      sizeInCM: "Grösse in CM",
      printMode: "Matériau / Couleur",
      quantity: "Quantité",
      priceSingle: "pièce",
      priceSum: "Somme totale",
      delete: "Supprimer",
      attachments: "Pièces jointes",
      uploadAttachment: "Charger les pièces jointes",
    },
  },
  requiredInput: {
    someWith: "Einige mit",
    notFilled: "markierte Pflichtfelder sind noch nicht ausgefüllt."
  },
  condition1: "J'ai pris connaissance des",
  condition2: "Conditions générales de vente",
  condition3: "et je les accepte.",
  orderStatusLabels: {
    QUOTE_GENERATED: "Offre demandée",
    ORDER_RECEIVED: "Commande reçue",
    READY_FOR_PROCESSING: "Prêt pour le traitement",
    CUSTOMER_CONTACTED: "Le client a été contacté",
    FILES_PRINTABLE: "Les fichiers sont imprimables",
    FILES_REPAIRED: "Datei wurde repariert",
    FILES_NOT_PRINTABLE: "Les fichiers ne sont pas imprimables",
    SUPPLIER_REQUEST_SENT: "Requête envoyée au fournisseur",
    IN_PRODUCTION: "Les pièces sont en production",
    PARTS_DEFECTIVE: "Les pièces sont défectueuses",
    PARTS_REVIEWED: "Les pièces sont sans défaut",
    ORDER_CANCELLED: "Commande annulée",
    ORDER_COMPLETED: "Commande effectuée",
    UNKNOWN: "Ouverte",
  },
  paymentMethodLabels: {
    prepaid: "Prépaiement",
    billing: "Facturation",
    quote: "Demande de devis",
    paypal: "PayPal",
  },
  productionTime: "Durée de production",
  deliveryTime: "le délai de livraison",
  productionTimeDays: "0 jour ouvrable | 1 jour ouvrable| {n} jours ouvrables",
  totalDeliveryTime: "Délai de livraison total estimé",
  totalShippingTime: "Délai d’expédition prévu",
  paymentDetails: {
    customerAndPaymentDetails: "Client et mode de paiement",
    completeYourOrder: "Complétez votre commande",
    customer: "Client",
    billingAddress: "Adresse de facturation",
    totalPaymentAmount: "Montant total",
    shippingAddress: "Adresse de livraison",
    address: "Adresse",
    totalPrice: "Prix total (hors frais de port)",
    minimumQuantitySurcharge: "Supplément pour petites quantités",
    diffrentShippingAddress: "abweichend wie Lieferadresse",
    yourMessageToUs: "Ihre Nachricht an uns",
    label: "Label",
    button: "Button",
    sippingCost: "Versandkosten",
    subTotal: "Somme",
    netPrice: "Nettopreis",
    sumPrice: "Bruttopreis",
    client: "Client",
    shippingCost: "Frais de port",
    inputLabels: {
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Adresse e-mail",
      phone: "Téléphone",
      company: "Entreprise / Département",
      referenceNumber: "Numéro de référence",
      street: "Rue",
      postalCode: "Code postal",
      city: "Ville",
      country: "Pays",
      shippingAddressDiffersFromBillingAddress:
        "diffère de l'adresse de facturation",
      paymentMethod: "Mode de paiement",
      vatRegistrationNumber: "Numéro d'enregistrement de la TVA",
      businessOrPrivateCustomer: "Je suis:",
      businessCustomer: "Client entreprise",
      privateCustomer: "Client privé",
      saveNewAddress: "Enregistrer l'adresse pour ma prochaine commande",
    },
    paymentMethod: "Mode de paiement",
  },
  finaliseOrder: {
    buyNow: "S'engager à acheter",
    goToPayPal: "Continuer vers PayPal",
    getQuote: "Obtenir un devis",
    thankYouForOrdering: "Merci pour votre commande.",
    orderConfirmationSentTo:
      'Nous avons envoyé une confirmation de réception à <span class="has-text-primary">{email}</span>.',
    paymentConfirmationSentTo:
      'Nous avons envoyé une confirmation de paiement à <span class="has-text-primary">{email}</span>.',
  },
  billing: "facture d'achat",
  quote: "demander une offre sans engagement",
  quoteGenerated: {
    headline: "Merci pour votre demande.",
    emailSentTo:
      'Nous vous avons envoyé une offre par courriel à l’adresse <span class=""has-text-primary"">{email}</span>.',
    emailSent: "Nous avons envoyé un devis sans engagement à {email}.",
  },
};
